module.exports = __webpack_public_path__ + "static/media/MEADOWBROOK_ESTATES_ASSOCIATION_BYLAWS.536f6713.pdf";